import $ from 'jquery';

$('.accordion--simple .accordion-title').click(function () {
    $(this).parents('.accordion--simple').toggleClass('accordion--opened');
});
